import LazyLoad from 'vanilla-lazyload';
import $ from 'zepto-webpack';
import { sendEvent } from '@utils/track';
import { getQueryObject, Timers, fetch_timeout} from '@utils/index';
import {countryCode, countryText} from './constant'
window.jQuery = $;

import './index.css';

const apiUrl = process.env.AIR_GATAWAY;
const extranetApiUrl = process.env.BUILD_TYPE === 'prod' ?  process.env.AIR_GATAWAY : 'https://air-class-gateway-fat-alhz.zmaxis.com'
const newGateWay = process.env.BUILD_TYPE === 'prod' ? 'https://ac-operation-gateway.air-class.com' : 'https://ac-operation-gateway-fat-alhz.inzm.com'
$(function () {
  // 参数
  const { channel_code = '', channel_keyword = '' } = getQueryObject();
  // 表单后一个模块
  const slideOffset = $('.slide-box').offset();
  const $fixedFooterEle = $('.fixed-footer');
  sendEvent({
    eventId: 'en_adPage0729_PageView',
    eventParam: {
      channel_code,
      channel_keyword,
    },
  });

  // 懒加载
  new LazyLoad({
    elements_selector: '.lazy',
    threshold: 0,
  });

  const dictCache = {
    gradeList: null,
    subjectList: null,
  };
  // 表单
  const submitFormData = {
    firstName: $('input[name=nature]').val(),
    lastName: $('input[name=name]').val(),
    gradeCode: '',
    subjectCode: '',
    mobile: '',
    checked: false,
  };
  // 获取字典信息
  getDictInfo()
    .then((res) => {
      // 年级
      dictCache.gradeList = res;
      const gradeStr = handleGradeTemplate(res);
      $('select[name=grade]').html(gradeStr);
      // 科目
      dictCache.subjectList = res[0].subjectList;
      const subjectStr = handleSubjectTemplate(res[0].subjectList);
      $('select[name=subject]').html(subjectStr);
    })
    .catch((err) => {
      toast(err.message);
    });

  // 设置地域 select
  const countryCodeArr = Object.keys(countryText).reduce((pre,next) => {
    pre[next] = {
      text: countryText[next],
      code: Object.keys(countryCode).find((key) => countryCode[key].find(code=> code === next)) || ''
    }
    return pre
  }, {})
  $('select[name=areaCode]').html(handleAreaTemplate(countryCodeArr))

  //获取当前地域信息
  getIp()
  .then((res) => {
    if (res && res.countryId) {
      const areaCode = Object.keys(countryCode).find((key) => countryCode[key].find(code=> code === res.countryId)) || '44'
      $('select[name=areaCode]').val(areaCode)
    } else {
      $('select[name=areaCode]').val('44')
    }
  })
  .catch((err) => {
    $('select[name=areaCode]').val('44')
    toast(err.message);
  });

  /**
   * 年级切换
   */
  $('select[name=grade]').on('change', function () {
    submitFormData.gradeCode = $(this).val();
    const findItem = dictCache.gradeList.find((v) => v.gradeCode === submitFormData.gradeCode);
    dictCache.subjectList = findItem.subjectList || [];
    const subjectStr = handleSubjectTemplate(dictCache.subjectList);
    $('select[name=subject]').html(subjectStr);
  });
  /**
   * 姓氏失去焦点
   */

  $('input[name=name]').blur(function () {
    sendEvent({
      eventId: 'en_adPage0729_LastNameInput',
      eventParam: {
        channel_code,
        channel_keyword,
        lastname: $(this).val(),
      },
    });
  });
  /**
   * 名字失去焦点
   */

  $('input[name=nature]').blur(function () {
    sendEvent({
      eventId: 'en_adPage0729_NameInput',
      eventParam: {
        channel_code,
        channel_keyword,
        name: $(this).val(),
      },
    });
  });

  /**
   * 年级选择
   */

  $('select[name=grade]').change(function () {
    sendEvent({
      eventId: 'en_adPage0729_Grade',
      eventParam: {
        channel_code,
        channel_keyword,
        grade: $(this).val(),
      },
    });
  });
  /**
   * 科目选择
   */

  $('select[name=subject]').change(function () {
    sendEvent({
      eventId: 'en_adPage0729_SubjectSelect',
      eventParam: {
        channel_code,
        channel_keyword,
        subject: $(this).val(),
      },
    });
  });
  /**
   * 手机号
   */

  $('input[name=phone]').blur(function () {
    sendEvent({
      eventId: 'en_adPage0729_PhoneInput',
      eventParam: {
        channel_code,
        channel_keyword,
        phone: $(this).val(),
      },
    });
  });
  //

  /**
   * 科目切换
   */
  $('select[name=subject]').on('change', function () {
    submitFormData.subjectCode = $(this).val();
  });

  // 文本框输入值记录
  $('input.txt').change(function (e) {
    const { key } = e.currentTarget.dataset;
    submitFormData[key] = $(this).val();
  });
  // 修改状态
  $('input[name=ucheck]').change(function () {
    if (this.checked) {
      sendEvent({
        eventId: 'en_adPage0729_Agreement',
        eventParam: {
          channel_code,
          channel_keyword,
        },
      });
    }
    submitFormData.checked = this.checked;
  });

  /**
   * 点击tab切换
   */
  $('.tab').on('click', function (e) {
    const { id } = e.currentTarget.dataset;
    $('.tab').removeClass('active');
    $(this).addClass('active');
    const moveLeft = $('#' + id).get(0).offsetLeft;
    $('#' + id)
      .parent()
      .scrollLeft(!moveLeft ? 0 : moveLeft + 30);
  });

  /**
   * 滑动切换
   */
  $('.grade-intro .scroll-view').scroll(function(e) {
    const curScrollLeft = $(this).get(0).scrollLeft

    $(".grade-intro .scroll-view .s-item").each(function(index){
      const screenWidth = document.documentElement.clientWidth || document.body.clientwidth;
      const xb = index + 1
      const disVal = screenWidth >=540 ? 150 : 50
      if (curScrollLeft > $('#tab' + xb).get(0).offsetLeft - disVal) {
        $('.tab').removeClass('active');
        $('.tab').eq(index).addClass('active');
      }
    });

  })
  // 添加滚动监听
  window.addEventListener('scroll', (e) => {
    if (window.scrollY >= slideOffset.top - 100) {
      $fixedFooterEle.addClass('show');
    } else {
      $fixedFooterEle.removeClass('show');
    }
  });

  /**
   * 底部区域点击
   */
  $fixedFooterEle.on('click', function () {
    $('.form-box').get(0).scrollIntoView();
    $(this).removeClass('show');
    sendEvent({
      eventId: 'en_adPage0729_ClickFooterButton',
      eventParam: {
        channel_code,
        channel_keyword,
      },
    });
  });

  // 接口处理
  $('.submit-btn').on('click', () => {
    console.log(submitFormData,'submitFormDatasubmitFormData')
    const reportMsg = (result) => {
      sendEvent({
        eventId: 'en_adPage0729_ClickSubmit',
        eventParam: {
          channel_code,
          channel_keyword,
          result,
        },
      });
    }
    const areaCode =  $('select[name=areaCode]').val();
    const nameRules = /^[A-Za-z]*(\s[A-Za-z]*)*$/
    const LIMIT_TEN_LENGTH = 10;
    const ENGLISH_AREAC_CODE = 44
    // 表单教研
    if (!submitFormData.firstName || !submitFormData.lastName || !nameRules.test(submitFormData.firstName) ||  !nameRules.test(submitFormData.lastName)) {
      toast('Errors in first name/last name');
      reportMsg('Errors in first name/last name')
      return;
    }

    if (!submitFormData.gradeCode || !submitFormData.subjectCode) {
      toast('Please select grade and subject');
      reportMsg('Please select grade and subject')
      return;
    }

    if (!submitFormData.mobile) {
      toast('Please fill in the phone number');
      reportMsg('Please fill in the phone number')
      return;
    }
    if (submitFormData.mobile.length !== LIMIT_TEN_LENGTH && +areaCode === ENGLISH_AREAC_CODE) {
      toast('Incorrect number format');
      reportMsg('Incorrect number format')
      return;
    }

     // policy
    if (!submitFormData.checked) {
      toast('Please read and consent to the User Agreement and Privacy Policy');
      reportMsg('Please read and consent to the User Agreement and Privacy Policy')
      return;
    }

    fetchReserve(
      Object.assign(submitFormData, {
        name: submitFormData.firstName + ' ' + submitFormData.lastName,
        id: '2',
        code: channel_code,
        key: channel_keyword,
        segmentCode: 'landingPageWithName',
        areaCode: $('select[name=areaCode]').val(),
      })
    );
  });

  /**
   * 获取字典信息
   */
  function getDictInfo() {
    return fetch(`${newGateWay}/air/landing/page/air/appointment/2/2`, {
      method: 'POST',
      body: JSON.stringify({
        id: 2,
        segmentCode: 'dictInfo',
      }),
      headers: {
        'content-type': 'application/json;charset=UTF-8',
        'Api-Version': '1.0.0',
        'App-Name': 'KidsH5',
      },
    })
      .then((res) => res.json())
      .then((response) => {
        if (+response.code === 0) {
          return response.data.dictInfo;
        }
        throw new Error(response.message);
      });
  }
   /**
   * 获取IP信息
   */
  function getIp() {
    return fetch_timeout(fetch(`${extranetApiUrl}/air-ips/api/ip`, {
      method: 'GET',
      headers: {
        'content-type': 'application/json;charset=UTF-8',
        'Api-Version': '1.0.0',
        'App-Name': 'KidsH5',
      }
    }))
      .then((res) => res.json())
      .then((response) => {
        console.log(response,'responseresponse')
        if (+response.code === 0) {
          return response.data
        }
        throw new Error(response.message);
      });
  }


  let isSubmit = false;
  /**
   * 预约请求
   */
  function fetchReserve(params) {
    if (isSubmit) return;
    isSubmit = true;
    fetch(`${newGateWay}/air/landing/page/air/appointment/2/2`, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'content-type': 'application/json;charset=UTF-8',
        'Api-Version': '1.0.0',
        'App-Name': 'KidsH5',
      },
    })
      .then((res) => res.json())
      .then((res) => {
        sendEvent({
          eventId: 'en_adPage0729_SubmitResult',
          eventParam: {
            channel_code,
            channel_keyword,
            result: res.message || '',
          },
        });
        isSubmit = false;
        if (+res.code === 0) {
          gtag('event', 'conversion', { send_to: 'AW-328519748/ZImKCMzq5t4CEMSg05wB' });
          gtag('event', 'conversion', { send_to: 'AW-346007589/erxeCPOq7d4CEKXQ_qQB' });
          gtag('event', 'conversion', { send_to: 'AW-328316016/rUbiCJHr0t4CEPDoxpwB' });
          gtag('event', 'conversion', { send_to: 'AW-327291236/tAqYCJqFqd8CEOSiiJwB' });
          gtag('event', 'conversion', { send_to: 'AW-327291257/WXLrCPG7qd8CEPmiiJwB' });
          gtag('event', 'conversion', { send_to: 'AW-327802922/W5LcCOvD1t8CEKrAp5wB' });
          function gtag_report_conversion(url) {
            var callback = function () {
              if (typeof url != 'undefined') {
                window.location = url;
              }
            };
            gtag('event', 'conversion', { send_to: 'AW-327843671/x22XCNyp-N4CENf-qZwB', event_callback: callback });
            return false;
          }
          gtag_report_conversion()
          fbq('track', 'Lead');
          window.location.href = '/en/landing/result/?channel_code=' + channel_code + '&channel_keyword=' + channel_keyword;
        } else {
          toast(res.message);
        }
      })
      .catch((err) => {
        isSubmit = false;
        toast(err.message || 'network error');
      });
  }

  /**
   * 模板处理
   */
  function handleSubjectTemplate(data) {
    return data.reduce(
      (str, cur) => (str += '<option value="' + cur.subjectCode + '">' + cur.subjectName + '</option>'),
      '<option value="" disabled selected>Subject</option>'
    );
  }

  /**
   * 处理年级数据
   * @returns
   */
  function handleGradeTemplate(data) {
    return data.reduce(
      (str, cur) => (str += '<option value="' + cur.gradeCode + '">' + cur.gradeName + '</option>'),
      '<option value="" disabled selected>Grade</option>'
    );
  }
   /**
   * 区域处理
   * @returns
   */
  function handleAreaTemplate() {
    return Object.keys(countryCodeArr).reduce(
      (str, cur) => (str += '<option value="' + countryCodeArr[cur].code + '">' + countryCodeArr[cur].code + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + countryCodeArr[cur].text + '</option>'),
      "<option style='display: none'></option>")
  }
  /**
   * toast提示
   */
  function toast(msg) {
    const div = document.createElement('div');
    const divInner = document.createElement('div');
    div.className = 'toast';
    divInner.className = 'toast-inner';
    divInner.innerText = msg;
    div.appendChild(divInner);
    document.body.appendChild(div);
    setTimeout(() => {
      document.body.removeChild(div);
    }, 1500);
  }
});


